<div class="collection-view">
    @if (errorType) {
        @if (errorType === 'shared') {
            <div class="row justify-content-center">
                <div class="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
                    <div class="error-box">
                        <div class="error-wrapper">
                            <div class="icon-wrapper"><mat-icon fontIcon="cancel"></mat-icon></div>
                            <div class="mt-3"><h1>{{'error.sharedCollection' | translate}}</h1></div>
                        </div>
                    </div>
                </div>
            </div>
        }
        @if (errorType === 'transfer') {
            <div class="row justify-content-center">
                <div class="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
                    <div class="error-box">
                        <div class="error-wrapper">
                            <div class="icon-wrapper"><mat-icon fontIcon="cancel"></mat-icon></div>
                            <div class="mt-3"><h1>{{'error.transferCollection' | translate}}</h1></div>
                        </div>
                    </div>
                </div>
            </div>
        }
        @if (errorType === 'generic') {
            <div class="row justify-content-center">
                <div class="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
                    <div class="error-box">
                        <div class="error-wrapper">
                            <div class="icon-wrapper"><mat-icon fontIcon="cancel"></mat-icon></div>
                            <div class="mt-3"><h1>{{'error.generic404' | translate}}</h1></div>
                        </div>
                    </div>
                </div>
            </div>
        }
    }
</div>
